import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const BrokenFeetIllustration = ({ width = 40, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <path fill="#F8BB9F" d="M33.1 32.62h4.684s2.89-.083 2.07 2.168c-.492 1.351-3.092 3.45-6.754 4.565V32.62z" />
        <path fill="#F6F6F6" d="M33.1 31.974L33.1 39.999 24.078 39.999z" />
        <path
          fill="#F8BB9F"
          d="M2.973 1.906C2.973.853 3.825 0 4.875 0h8.748c1.052 0 1.902.853 1.902 1.906v7.125H2.972V1.906z"
        />
        <path fill="#F6F6F6" d="M1.346 16.433L16.974 16.433 16.974 9.033 1.346 9.033z" />
        <path
          fill="#EDEDED"
          d="M21.99 28.482c-.459-.21-1.243-.706-2.15-1.314-1.763-1.177-2.814-3.162-2.829-5.28l-.036-5.455L.132 34.274c-.236.981-.162 2.034.275 2.998C1.161 38.932 2.817 40 4.641 40l6.574-.01L21.99 28.481z"
        />
        <path
          fill="#F6F6F6"
          d="M.13 34.274l7.057-7.476-5.84-5.85s.104 3.951 0 5.06c-.08.844-.237 2.531-.315 3.373-.13 1.382-.932 4.91-.932 4.91l.023.035c.004-.017.004-.035.008-.052"
        />
        <path
          fill="#DADADA"
          d="M1.347 16.433L1.347 20.948 7.188 26.799 16.976 16.433zM24.078 40L11.214 39.989 21.99 28.481 33.099 31.974z"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M17.337 30.91c1.312.877 2.116 1.358 2.77 1.66l12.994 4.111v-4.708L21.989 28.48c-.46-.21-1.242-.705-2.151-1.313-1.761-1.177-2.813-3.16-2.826-5.28l-.036-5.456v-7.4h-4.5l.036 12.888c.024 3.625 1.828 6.986 4.825 8.99"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M36.644 37.814c1.737-1.017 2.898-2.17 3.21-3.026.82-2.25-2.07-2.168-2.07-2.168H33.1v4.072l3.544 1.122zM13.624 0h-3.301v9.032h5.202V1.906C15.525.854 14.675 0 13.624 0"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
